import {Button, Dropdown, Tag} from '@/components/atoms'
import {useSelector} from 'react-redux'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {segmentOptions} from '@/utils/constants/promotionConstants'
import {SegmentTags} from '../SegmentModal/SegmentTags'
import './segmentGroup.scss'

export const SegmentGroup = ({
  groupIndex,
  segmentGroup,
  onSegmentSelection,
  dropdownLabel = '',
  tagsSeparator = 'AND',
  handleDeleteGroup = null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleRemove = (_segmentId, _groupIndex) => {},
}) => {
  const countryCode = useSelector(selectCountryCode)
  const allSegmentIds = segmentGroup?.segments || []
  const label = dropdownLabel || (groupIndex !== null ? `Group ${groupIndex + 1}` : 'Segments')
  const availableSegmentOptions =
    countryCode === 'MX' ? segmentOptions : segmentOptions.filter(option => option.id !== 'Create New Segment')

  const canDelete = groupIndex !== null && groupIndex > 0 && handleDeleteGroup !== null
  const totalSelections = allSegmentIds.length

  const getSelectionText = () => {
    if (totalSelections === 0) return null
    if (totalSelections === 1) return 'One selected'
    return 'Multiple selected'
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-start">
        <div className="products-admin-segment-section-tag-wrapper relative flex items-center gap-2">
          <Dropdown
            isJsonWrap={false}
            childList={availableSegmentOptions}
            isDark
            placeholder="Select Segment(s)"
            label={label}
            updateValue={items => onSegmentSelection(items, groupIndex)}
            autocomplete="off"
          />

          {totalSelections > 0 && (
            <>
              <div className="selection-overlay pointer-events-none absolute left-0 flex w-full items-center px-3">
                <span className="bg-gray-800 text-sm text-white">{getSelectionText()}</span>
              </div>
              <Tag text={`${totalSelections}`} color="blue" className="absolute right-0" />
            </>
          )}
        </div>

        {canDelete && (
          <Button
            handleButton={() => handleDeleteGroup(groupIndex)}
            uiSchema={{
              className: 'ml-4 mt-5',
              size: 'small',
              variant: 'tertiary',
            }}
          >
            Delete Group
          </Button>
        )}
      </div>

      {allSegmentIds.length > 0 && (
        <div className="mt-4">
          <SegmentTags
            segments={allSegmentIds}
            handleTagRemove={segment => handleRemove(segment.segmentId, groupIndex)}
            color="green"
            separator={tagsSeparator}
          />
        </div>
      )}
    </div>
  )
}
